<a-multiple-avatars [users]="users$ | async" [showDetails]="showDetails"></a-multiple-avatars>